import { HelpVideo } from '../../../app/core/help/HelpVideo';

export const AllBoardsHaug = HelpVideo(
    'AllBoards',
    'Dashboard / Views',
    'All Boards',
    2010,
    'https://deqo-prod-app-static.ams3.digitaloceanspaces.com/app/haug/02010-all-boards.mp4',
);
